<template>
  <div>
    <div
      class="form-group variable-selector">
      <div>
        <div class="label">{{label}}</div>
        <div class="single-select-wrapper">
          <vue-single-select
            :placeholder="''"
            class="selection-left"
            :class="disabled ? 'not-clearable' : null"
            v-model="variable"
            v-on:input="$emit('input', variable)"
            :options="variables"
            :disabled="disabled"
            :option-label="'label'"
            :max-results="getMaxResults"/>
          <btn-pill
            v-if="!disabled"
            v-has-feature="'Taxonomy'"
            class="tags-btn"
            @click="showModal = true"
            btn-size="s"
            btn-type="secondary">
            <font-awesome-icon
              :icon="icon.tags"/>
            {{ $t('variables.tags') }}
          </btn-pill>
        </div>
      </div>
    </div>
    <variable-selector-modal
      v-if="showModal"
      v-model="variable"
      :variables="variables"
      :selected-tags="selectedTags"
      :tagged-variables="taggedVariables"
      :tree="tree"
      v-on:close="showModal = false"
      v-on:input="$emit('input', variable)"
      v-on:selectedTagsChanged="selectedTagsChanged"/>
  </div>
</template>

<script>
import VariableSelectorModal from '@/components/variable/VariableSelectorModal';
import vSelect from 'vue-select';
import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
import { faTags } from '@fortawesome/pro-regular-svg-icons';
import BtnPill from '@/components/shared/buttons/BtnPill';
import LabelSelect from '@/components/shared/forms/LabelSelect';
import VueSingleSelect from 'vue-single-select';
import variableSelectorMixin from '@/components/explorer/variableSelectorMixin';

export default {
  name: 'LabelVariableSelector',
  components: {
    LabelSelect,
    BtnPill,
    vSelect,
    VariableSelectorModal,
    FontAwesomeIcon,
    VueSingleSelect
  },
  props: {
    value: {
      type: Object,
      default: () => {}
    },
    variables: {
      type: Array,
      default: () => []
    },
    taggedVariables: {
      type: Array,
      default: () => []
    },
    tree: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    },
    label: {
      type: String
    },
    placeholder: {
      type: String
    },
    type: {
      type: String,
      default: 'text'
    },
    error: {
      type: Boolean,
      default: false
    },
    errorMessage: {
      type: String,
      default: 'Error'
    }
  },
  watch: {
    value: {
      handler: function (value) {
        this.variable = value;
      }
    }
  },
  mixins: [
    variableSelectorMixin
  ],
  data () {
    return {
      variable: this.value,
      showModal: false,
      icon: {
        tags: faTags
      },
      selectedTags: []
    };
  }
};
</script>

<style lang="scss" scoped>
  @import "../../stylesheets/variables.scss";

  .tags-btn {
    white-space: nowrap;
    margin-left: $sp-margin-smaller;
  }

  .single-select-wrapper {
    display: flex;
    align-items: baseline;
  }

  .selection-left {
    width: 100%;
  }

  .label {
    color: $black-trans4;
  }

  /deep/ .not-clearable .single-select-wrapper .cursor-pointer {
    display: none;
  }

  /deep/ .not-clearable .search-input {
    background-color: $disabled !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/variable/LabelVariableSelector.vue